import React from "react";
import Reveal from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Rezervace",
    body:
      "Vyplníte krátký formulář. Během 24 hodin se vám ozveme se všemi detaily a platebními údaji.",
  },
  {
    n: "02",
    title: "Úhrada voucheru",
    body:
      "Zaplatíte 6 999 Kč bankovním převodem. Obratem obdržíte elektronický voucher s unikátním kódem.",
  },
  {
    n: "03",
    title: "Užíváte si",
    body:
      "Kdykoli si rezervujete službu ve kterékoli pobočce — Čestlice nebo Butovice. Prioritně, bez čekání. Platnost 3 roky.",
  },
];

export const Process = () => {
  return (
    <section id="proces" data-testid="process-section" className="relative py-20 sm:py-24 md:py-36 bg-[#070707]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <Reveal className="max-w-3xl">
          <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
            06 — Jak to probíhá
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Tři kroky.
            <br />
            <span className="italic text-gold-gradient">Žádné závazky navíc.</span>
          </h2>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-white/5">
          {steps.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 120}
              className="bg-[#060606] p-7 sm:p-10 md:p-12 group"
            >
              <div data-testid={`process-step-${i}`} className="flex flex-col h-full">
                <div className="flex items-baseline justify-between mb-7 sm:mb-10">
                  <span className="font-display text-5xl sm:text-6xl text-gold-gradient leading-none">
                    {s.n}
                  </span>
                  <span className="w-10 sm:w-12 h-px bg-[#D4AF37]/30 group-hover:w-20 group-hover:bg-[#D4AF37] transition-all duration-500" />
                </div>
                <h3 className="font-display text-2xl sm:text-3xl text-white mb-3 md:mb-4">{s.title}</h3>
                <p className="text-sm text-zinc-400 font-light leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
